import { ajax } from '../index'

/**
 * featrue deals Api
 */
export default {
  // 获取左侧筛选分类
  getSidebarFilter(topic: string, dataObj?: any) {
    return ajax.get('api', `/api/v1/sidebar/filter/${topic}`, dataObj)
  },

  // 获取FeaturedDeals数据
  getFeaturedDealsData(dataObj?: any) {
    return ajax.get('api', `/api/v1/product/list/featured-deals`, dataObj)
  }
}